<script setup lang="ts">
import {useExperienceStore} from "@/stores/experience.store";
import BaseCard from "@/core/components/base/BaseCard.vue";
import VideoItem from "@/video/components/VideoItem.vue";

const {events} = useExperienceStore();
</script>

<template>
  <h2>Comment obtenir des Apodis Coins ?</h2>
  <p class="text-primary">
    C'est facile ! Il suffit de remplir les missions ci-dessous pour gagner le lot associé :
  </p>
  <BaseCard
    v-for="event in events"
    :key="event.id"
    class="flex flex-row justify-between my-4 p-4"
  >
    <div class="w-[80%]">
      <h3 class="text-primary">
        {{ event.name }}
      </h3>
      <p class="text-primary">
        {{ event.description }}
      </p>
      <div v-if="event.video" class="pt-2">
        <VideoItem :video="event.video" />
      </div>
    </div>
    <div class="flex flex-row items-center justify-center gap-2">
      <p class="text-primary font-semibold text-3xl pt-1">
        {{ event.value }}
      </p>
      <img
        src="@/assets/images/apodis-coin.png"
        alt="apodis-coin"
        class="w-10 h-10"
      >
    </div>
  </BaseCard>
</template>
